import React from 'react'
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Slider, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface FaceFixerProps {
  method: 'GFPGAN' | 'CodeFormers'
  strength: number
  setMethod: (m: 'GFPGAN' | 'CodeFormers') => void
  setStrength: (v: number) => void
}

export function FaceFixer({ method, strength, setMethod, setStrength }: FaceFixerProps) {
  return (
    <Accordion sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Face Fixer</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <RadioGroup value={method} onChange={(e) => setMethod(e.target.value as 'GFPGAN' | 'CodeFormers')}>
          <FormControlLabel value="GFPGAN" control={<Radio />} label="GFPGAN" />
          <FormControlLabel value="CodeFormers" control={<Radio />} label="CodeFormers" />
        </RadioGroup>

        <Box sx={{ mt: 2 }}>
          <Typography gutterBottom>Strength: {strength.toFixed(2)}</Typography>
          <Slider
            value={strength}
            onChange={(e, val) => setStrength(val as number)}
            min={0}
            max={1}
            step={0.01}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
